module.exports = "/images/logomrental.svg?1054f02ba670f468f3b00f9631ffd3d2";